import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = { class: "col-sm-12 col-md-6 col-lg-6" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "col-sm-12 col-md-6 col-lg-6" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = {
  key: 0,
  role: "alert",
  class: "alert alert-custom alert-danger fade show mt-4 mb-0"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-1 p-0 text-danger" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-vcard-fill fs-3 p-0 me-2 text-white" }, null, -1)
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = {
  key: 0,
  class: "bi bi-search fs-6 p-0 me-2 text-white"
}
const _hoisted_13 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    title: _ctx.t('search'),
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "lock-scroll": "",
    "append-to-body": "",
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "danger",
          disabled: _ctx.loader,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.t("cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.data.status == true && _ctx.data.payroll != null)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.viewInfo
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t("viewInfo")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              loading: _ctx.loader,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitForm(_ctx.searchFormRef)))
            }, {
              default: _withCtx(() => [
                (!_ctx.loader)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t("search")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref: "searchFormRef",
        model: _ctx.searchForm,
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t("typeDocument")), 1),
              _createVNode(_component_el_form_item, {
                prop: "doctype",
                rules: [{
                        required: true,
                        message: 'Campo requerido',
                        trigger: ['blur', 'change'],
                    }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.searchForm.doctype,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.doctype) = $event)),
                    onChange: _ctx.changeDocType,
                    placeholder: "Seleccione",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocuments, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          value: item.id,
                          label: item.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t("nroDocument")), 1),
              _createVNode(_component_el_form_item, {
                prop: "docnumber",
                rules: [
                        { required: true, message: _ctx.t('obligatorie'), trigger: ['change', 'blur'] },
                        { min: _ctx.minlength, message: `Campo requiere ${_ctx.maxlength} dígitos`, trigger: ['change', 'blur']},
                        { pattern: _ctx.pattern, message: 'Solo números', trigger: ['change', 'blur']}
                    ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: "inputRef",
                    modelValue: _ctx.searchForm.docnumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.docnumber) = $event)),
                    modelModifiers: { trim: true },
                    minlength: _ctx.minlength,
                    maxlength: _ctx.maxlength,
                    "show-word-limit": true,
                    onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.submitForm(_ctx.searchFormRef)), ["enter"]))
                  }, null, 8, ["modelValue", "minlength", "maxlength"])
                ]),
                _: 1
              }, 8, ["rules"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _ctx.loader]
      ]),
      (_ctx.data.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "alert-text",
              innerHTML: _ctx.data.message
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onOpen", "onOpened", "onClosed"]))
}